import CustomLoadingButton from "@/components/Button/CustomLoadingButton";
import CustomToggleButton from "@/components/Button/CustomToggleButton";
import CustomAutocomplete from "@/components/Form/InputFields/CustomAutocomplete";
import CustomInput from "@/components/Form/InputFields/CustomInput";
import SpacingGrid from "@/components/Grid/SpacingGrid";
import { Box } from "@mui/material";
import { IFormProps } from "../beeswaxList.interface";
import { listTypeList } from "../data";
export default function Overview({
  errors,
  control,
  getValues,
  setValue,
  isEdit = false,
  defaultListType,
}: IFormProps & { defaultListType: any }) {
  return (
    <SpacingGrid spacingType="form">
      <SpacingGrid item>
        <CustomInput
          label="List ID"
          name="id"
          control={control}
          error={errors?.id?.message}
          placeholder="List ID"
          readOnly
          disabled
        />
      </SpacingGrid>
      <SpacingGrid item>
        <CustomAutocomplete
          label="List Type"
          name="type"
          itemList={listTypeList}
          error={errors?.type?.message}
          control={control}
          readOnly={isEdit || Boolean(defaultListType)}
          disabled={isEdit || Boolean(defaultListType)}
          required
        />
      </SpacingGrid>
      <SpacingGrid item>
        <CustomInput
          label="List Name"
          name="name"
          control={control}
          error={errors?.name?.message}
          required
        />
      </SpacingGrid>
      <SpacingGrid item>
        <CustomToggleButton
          name="active"
          control={control}
          label="Active"
          error={errors?.active?.message}
        />
      </SpacingGrid>
      <SpacingGrid item justifyContent="flex-end">
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <CustomLoadingButton
            title="Save & Close"
            isLoading={false}
            name="close"
            type="submit"
          />
          <CustomLoadingButton
            title="Save & Continue"
            isLoading={false}
            name="continue"
            type="submit"
          />
        </Box>
      </SpacingGrid>
    </SpacingGrid>
  );
}
